import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../../hooks/apiFetch";
import { useUser } from "./UserContext";

const UserFavContext = createContext();

export function UserFavProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [favBooks, setFavBooks] = useState(null);
    const [itemsLimit, setItemsLimit] = useState(5);
    const { isLogIn } = useUser();

    useEffect(() => {
        if (!isLogIn) {
            setFavBooks(null);
            setLoading(false);
            return;
        }
        async function fetchFavorits() {
            try {
                const data = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/library/favorite/books?page=${currentPage}&limit=1${itemsLimit}}`);
                setFavBooks(data);
            } catch (err) {
                setFavBooks(null)
            }
            finally {
                setLoading(false);
            }
        }
        fetchFavorits();
        // }
    }, [currentPage, itemsLimit, isLogIn]);

    return (
        <UserFavContext.Provider
            value={{
                loading, setLoading, favBooks, setFavBooks,
                currentPage, setCurrentPage,
                itemsLimit, setItemsLimit,
            }}>
            {children}
        </UserFavContext.Provider>
    );
}

export function useUserFav() {
    return useContext(UserFavContext);
}